module.exports = __webpack_public_path__ + "img/data-science.2b153814.svg";